/* Polling rate for internal/grab services */
export const GRAB_API_POLL_INTERVAL = 30000;

/**
 * Refresh rate when being throttled.
 * Note: Actual number used will be randomized between min and max (to prevent rate-limit echos)
 * @see views.main-view.jsx
 * @see common.utils.data-utils.js
 */
export const THROTTLED_REFRESH_RATE = {
  min: 45000,
  max: 60000,
};

export const RETRY_LOADING_DYNAMIC_DATA_TIMES = 3;

/* Polling rate for Googles direction services => (GRAB_API_POLL_INTERVAL * {n}) */
export const GOOGLE_API_POLL_FACTOR = 1;
/* URL param name for GUID */
export const ORDER_ID_PARAM_NAME = 'orderGUIDs';
/* Wrapper around data from response */
export const DATA_CONTAINER_NODE = 'webTrackingDetails';
